export default __webpack_public_path__ + "static/media/arrow.ff2d28ee.png";